import { h } from 'preact';

export default ({ src, placeholder }) => (
  <div class="as-ProfileImage">
    {src ? (
      <img
        alt="Profile"
        class="as-ProfileImage-image"
        id="asHeaderProfileImage"
        src={src}
      />
    ) : (
      placeholder
    )}
  </div>
);
